import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

export interface LineGraphInterface {}
export type CustomLineGraphProps = {
  data: LineGraphInterface[];
  chart: string;
  view?: string;
};

export const StyledLineGraph: React.FC<CustomLineGraphProps> = ({
  data,
  chart,
  view
}) => {
  let area1 = <></>;
  let area2 = <></>;
  if (chart === "overview") {
    if (view === "activePatients") {
      area1 = (
        <Area
          type="monotone"
          dataKey="Active Patients"
          stroke="#8884d8"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      );
      area2 = (
        <Area
          type="monotone"
          dataKey="Inactive Patients"
          stroke="#82ca9d"
          fillOpacity={1}
          fill="url(#colorPv)"
        />
      );
    } else if (view === "admitionStatus") {
      area1 = (
        <Area
          type="monotone"
          dataKey="Admited"
          stroke="#8884d8"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      );
      area2 = (
        <Area
          type="monotone"
          dataKey="Discharged"
          stroke="#82ca9d"
          fillOpacity={1}
          fill="url(#colorPv)"
        />
      );
    } else if (view === "timeRPM") {
      area1 = (
        <Area
          type="monotone"
          dataKey="RPM Time"
          stroke="#8884d8"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      );
    }
  } else if (chart === "group") {
    if (view === "groups") {
      area1 = (
        <Area
          type="monotone"
          dataKey="RPM Time"
          stroke="#8884d8"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      );
    }
  } else if (chart === "program") {
  } else if (chart === "coordinator") {
    area1 = (
      <Area
        type="monotone"
        dataKey="RPM Time"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUv)"
      />
    );
  } else if (chart === "patient") {
    area1 = (
      <Area
        type="monotone"
        dataKey="RPM Time"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUv)"
      />
    );
  } else if (chart === "devices") {
    area1 = (
      <Area
        type="monotone"
        dataKey="RPM Time"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUv)"
      />
    );
    area2 = (
      <Area
        type="monotone"
        dataKey="Interviened"
        stroke="#82ca9d"
        fillOpacity={1}
        fill="url(#colorPv)"
      />
    );
  } else if (chart === "spir") {
    area1 = (
      <Area
        type="monotone"
        dataKey="Flow(L/s)"
        stroke="#82ca9d"
        fillOpacity={1}
        fill="url(#colorPv)"
      />
    );
    area2 = (
      <Area
        type="monotone"
        dataKey="Max Flow(L/s)"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUv)"
      />
    );
  }
  return (
    <div>
      <AreaChart
        width={750}
        height={200}
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 10 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="name" />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend verticalAlign="top" height={36} />
        {area1}
        {area2}
      </AreaChart>
    </div>
  );
};
